import React from 'react';
import { withNativeProps } from '../../utils/native-props';
import classNames from 'classnames';
var classPrefix = "adm-result-page-card";
export var ResultPageCard = function ResultPageCard(props) {
  return withNativeProps(props, React.createElement('div', {
    className: classNames("".concat(classPrefix))
  }, props.children));
};